import { gql } from '@apollo/client';

export const CREATE_MEMBERSHIP_PLAN = gql`
   mutation CreateMembershipPlan($membership_duration_id:UUID!,$user_id:UUID!) {
    createMembershipPlan(membership_duration_id: $membership_duration_id, user_id: $user_id) {
         data {
            id
            membership_duration_id
            membership_end_date
            membership_join_date
            user_id
            membership_details {
                created_at
                description
                duration_type
                id
                number_of_days
                package_id
                price
                updated_at
                package {
                    created_at
                    description
                    id
                    name
                    package_type
                    updated_at
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;

export const UPDATE_MEMBERSHIP_PLAN = gql`
  mutation UpdateMembershipPlan($membership_duration_id:UUID!,$user_id:UUID!) {
    updateMembershipPlan(membership_duration_id: $membership_duration_id, user_id: $user_id) {
         data {
            id
            membership_duration_id
            membership_end_date
            membership_join_date
            user_id
            membership_details {
                created_at
                description
                duration_type
                id
                number_of_days
                package_id
                price
                updated_at
                package {
                    created_at
                    description
                    id
                    name
                    package_type
                    updated_at
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;


